export default __webpack_public_path__ + "static/media/logo_2.5a34f935.png";